import * as yup from "yup";

export const schema = yup.object().shape({
    search: yup
        .string()
        .required()
        .max(255)
        .test('hasText', 'Conteúdo é obrigatório', (v) => v.length > 0)
        .test(
            'minWords',
            'Escreva pelo menos 3 palavras',
            (v) => v.split(/\s+/).filter(Boolean).length >= 3
        ),
});